import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';
import {formatDate} from '../../../../helpers/utils';
import IconLink from '../../../../common/components/link/IconLink';

const UserDashboard = (props) => {
	const {state, translate} = props;
	const {workOrderStat, businessUnitStat, workOrdersNeedApproval} = state;

	const pieChartData = [
		{name: 'New', value: workOrderStat.new, fill: '#00c0ef'},
		{name: 'Approved', value: workOrderStat.approved, fill: '#00a65a'},
		{name: 'Not Approved', value: workOrderStat.not_approved, fill: '#f39c12'},
		{name: 'Alerted', value: workOrderStat.alert, fill: '#dd4b39'}
	];

	return (
		<Fragment>
			<div className='row'>
				<div className='col-sm-12'>
					<div className="small-box bg-teal-active">
						<div className="inner text-center">
							<p>{translate('dashboard_page_work_order_stat_total')}</p>
							<h3>{workOrderStat.total}</h3>
						</div>
						<div className="icon">
							<i className="fa fa-book"/>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-4">
					<div className="row">
						<div className="col-sm-6">
							<div className="small-box bg-aqua">
								<div className="inner">
									<p>{translate('dashboard_page_work_order_stat_new')}</p>
									<h3>{workOrderStat.new}</h3>
								</div>
								<div className="icon">
									<i className="fa fa-plus"/>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="small-box bg-green">
								<div className="inner">
									<p>{translate('dashboard_page_work_order_stat_approved')}</p>
									<h3>{workOrderStat.approved}</h3>
								</div>
								<div className="icon">
									<i className="fa fa-check"/>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="small-box bg-yellow">
								<div className="inner">
									<p>{translate('dashboard_page_work_order_stat_not_approved')}</p>
									<h3>{workOrderStat.not_approved}</h3>
								</div>
								<div className="icon">
									<i className="fa fa-ban"/>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="small-box bg-red">
								<div className="inner">
									<p>{translate('dashboard_page_work_order_stat_alerted')}</p>
									<h3>{workOrderStat.alert}</h3>
								</div>
								<div className="icon">
									<i className="fa fa-exclamation-triangle"/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
					<div className="box">
						<div className="box-body">
							<ResponsiveContainer height={200}>
								<PieChart>
									<Pie dataKey="value" innerRadius={40} outerRadius={80} paddingAngle={10}
									     label={{fill: '#000'}} data={pieChartData}
									/>
									<Tooltip/>
									<Legend/>
								</PieChart>
							</ResponsiveContainer>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
					<div className="box">
						<div className="box-body">
							<div className="table-responsive">
								<table className="table table-bordered table-striped table-condensed text-center">
									<thead>
										<tr>
											<th>{translate('dashboard_page_business_unit_stat_name')}</th>
											<th>{translate('dashboard_page_business_unit_stat_new')}</th>
											<th>{translate('dashboard_page_business_unit_stat_approved')}</th>
											<th>{translate('dashboard_page_business_unit_stat_not_approved')}</th>
											<th>{translate('dashboard_page_business_unit_stat_alerted')}</th>
										</tr>
									</thead>
									<tbody>
									{
										Object.keys(businessUnitStat).map((key, index) => (
											<tr key={`dashboard_page_business_unit_stat_${index}`}>
												<td>{businessUnitStat[key].name}</td>
												<td>{businessUnitStat[key].wo_new}</td>
												<td>{businessUnitStat[key].wo_approved}</td>
												<td>{businessUnitStat[key].wo_not_approved}</td>
												<td>{businessUnitStat[key].wo_alert}</td>
											</tr>
										))
									}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>

			{(workOrdersNeedApproval.length > 0) && (
				<div className='row'>
					<div className='col-sm-12'>
						<div className="box">
							<div className="box-body with-top-padding">
								<div className="small-box bg-olive">
									<div className="inner text-center">
										<h4>Work Order Needs Approval</h4>
									</div>
								</div>

								<div className="table-responsive">
									<table className="table table-bordered text-center">
										<thead>
											<tr>
												<td style={{background: '#d9edf7'}}>Work Order</td>
												<td style={{background: '#d9edf7'}}>Work Order Type</td>
												<td style={{background: '#d9edf7'}}>Customer</td>
												<td style={{background: '#d9edf7'}}>Description</td>
												<td style={{background: '#d9edf7'}}>PRR/NCN</td>
												<td style={{backgroundColor: '#d9edf7'}}>Start Date</td>
												<td style={{background: '#d9edf7'}}>Client Sign Off Status</td>
												<td style={{background: '#d9edf7'}}>Work Order Status</td>
											</tr>
										</thead>
										<tbody>
										{
											workOrdersNeedApproval.map((item, index) => (
												<tr key={`dashboard_page_work_order_needs_approval_${index}`}>
													<td><IconLink type="link" to={`/work-orders/detail/${item.id}`} text={item.code}/></td>
													<td>{item.type}</td>
													<td>{item.customer ? item.customer.name : ''}</td>
													<td>{item.job_description}</td>
													<td>{item.prr_ncn}</td>
													<td>{formatDate(item.start_date)}</td>
													<td>{item.client_approved_status}</td>
													<td>{item.work_order_status}</td>
												</tr>
											))
										}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</Fragment>
	);
};

UserDashboard.defaultProps = {
};

UserDashboard.propTypes = {
	state: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired
};

export default UserDashboard;